import { denormalize } from "normalizr";

import { noa } from "../../../api/schema";

export default state => {
  try {
    const items = state.noa.ids;

    const denormalized = denormalize(
      { items },
      { items: [noa] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
